import { useState } from 'react';
import { world } from '../../../languages';
import { WORLD_GROUPS } from '../../../languages/constants';
import { GeotargetingState } from '../../../reducers/geotargeting';
import { useAppSelector } from '../../../store';
import cookies from '../../../utils/browser-storage/cookies';
import isUITest from '../../../utils/is-ui-test';
import { DELAY_IN_DAYS, DISPLAY_CODES, STORAGE_KEY, TIMER_COOKIE_NAME } from '../new-worlds-launch-modal.constants';
import {
    is7DayTimerSet,
    shouldNeverBeShownAgain,
    trackPopupInteraction,
    wasShown7DaysAgo
} from '../new-worlds-launch-modal.utils';

export const useNewWorldsModal = () => {
    const [showModal, setShowModal] = useState(() => !is7DayTimerSet() && !shouldNeverBeShownAgain());
    const { countryCode, loaded }: GeotargetingState = useAppSelector((state) => state.main.geotargeting);
    const usersCountryCode = countryCode?.toLowerCase();

    const shouldBeDisplayedNow = () => {
        const usersCountryMatchesWebsiteWorld = usersCountryCode === world;
        const isPromotedCountrySupported = WORLD_GROUPS.SUPPLEMENTARY.includes(usersCountryCode);

        return isPromotedCountrySupported && !usersCountryMatchesWebsiteWorld && showModal;
    };

    const close = () => {
        trackPopupInteraction('popupClosed');
        if (wasShown7DaysAgo()) {
            window.storage.setItem(STORAGE_KEY, DISPLAY_CODES.NEVER_AGAIN);
        } else {
            window.storage.setItem(STORAGE_KEY, DISPLAY_CODES.SHOW_AGAIN_IN_7_DAYS);
            cookies.setItem(TIMER_COOKIE_NAME, 'true', DELAY_IN_DAYS);
        }

        setShowModal(false);
    };

    const confirm = () => {
        trackPopupInteraction(`userSwitchedWorld: ${usersCountryCode}`);
        window.storage.setItem(STORAGE_KEY, DISPLAY_CODES.NEVER_AGAIN);
        setShowModal(false);

        if (usersCountryCode) {
            window.location.href = `/${usersCountryCode}`;
        }
    };

    return {
        displayNow: shouldBeDisplayedNow() && loaded && !isUITest(),
        usersCountryCode,
        close,
        confirm
    };
};
